<template lang="pug">
v-container
  v-dialog(:value="!!imgInhalt" max-width="900" @input="imgInhalt = null")
    div
      v-img(v-if="imgInhalt" :src="imgInhalt" :max-width="900")
  
  v-layout(row, wrap)
    v-flex(xs12 sm4 v-for="content in ehrenamtContents")
      v-card
        v-card-title.grey.lighten-4.title {{ content.title }}
        v-card-text
          v-layout(wrap)
            v-flex(xs12): v-img(:src="content.previewImage" :max-height="450" :max-width="310")
            v-flex(xs12): v-btn(:href="content.downloads[1].url" target="_blank" flat color="primary") Zum PDF
            v-flex(xs12)
              div(@click="show(content.downloads[0].url)" style="cursor: pointer;")
                v-img(:src="content.downloads[0].url" :max-height="310" :max-width="310")
        
</template>

<style lang="stylus" scoped>
</style>

<script>
import gql from "graphql-tag";

export default {
  data() {
    return {
      ehrenamtContents: [],
      imgInhalt: null,
    };
  },
  apollo: {
    ehrenamtContents: {
      query: gql`
        query ExtraEhrenamt($catIds: [ID!]) {
          ehrenamtContents: beitraege(where: { categoryIdIn: $catIds }) {
            id
            categoryId
            kategorie {
              name
            }
            metaDescription

            title
            preamble
            content
            downloads {
              id
              url
              title
            }
            image
            previewImage
          }
        }
      `,
      variables() {
        return { catIds: [258] };
      },
    },
  },
  methods: {
    show(imgUrl) {
      this.imgInhalt = imgUrl;
    },
  },
}
</script>
